"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: "v-authorized",
    computed: {
        authorized: function () {
            return this.$store.state.authorized;
        }
    }
});
